
import { Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { CustomDialogModalComponent } from './../../shared/custom-dialog-modal/custom-dialog-modal.component';

@Injectable({
  providedIn: 'root'
})
export class DialogServiceService {
  constructor(private modalService: NgbModal) { }

  public confirm(
    title: string,
    message: string,
    btnOkText?: string,
    btnCancelText?: string,
    dialogSize: 'sm' | 'lg' = 'sm'): Promise<boolean> {
    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      size: dialogSize
    };
    const modalRef = this.modalService.open(CustomDialogModalComponent, ngbModalOptions);
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.btnOkText = btnOkText || 'OK';
    modalRef.componentInstance.btnCancelText = btnCancelText || '';

    return modalRef.result;
  }
}
